import React from 'react';
import propTypes from 'prop-types';
import omit from 'lodash/omit';

import ToggleInput, { toggleInputPropTypes } from './ToggleInput';

/**
 * This component should not be explicitly implemented. Please use the
 * <RadioButtonGroup /> component instead.
 */
const RadioButton = props => {
  return <ToggleInput type="radio" {...props} />;
};

// Type is manually implemented above and is not required as a propType
export const radioButtonPropTypes = {
  ...omit(toggleInputPropTypes, ['type']),
  value: propTypes.any.isRequired,
};

RadioButton.propTypes = radioButtonPropTypes;

export default RadioButton;
